import { CommonMessages, Locales } from '@monoimin/sb-types';
import { locales } from '@monoimin/constants';

import { getSharedData } from '../api/getSharedData';

const commonImport = {
  ru: () =>
    import(`../../../../../locales/ru.json`).then(
      (module) => module.default as CommonMessages
    ),
  en: () =>
    import(`../../../../../locales/en.json`).then(
      (module) => module.default as CommonMessages
    ),
  de: () =>
    import(`../../../../../locales/de.json`).then(
      (module) => module.default as CommonMessages
    ),
  tr: () =>
    import(`../../../../../locales/tr.json`).then(
      (module) => module.default as CommonMessages
    ),
  es: () =>
    import(`../../../../../locales/es.json`).then(
      (module) => module.default as CommonMessages
    ),
};

export async function getCommonMessages(
  locale: Locales | string = 'en'
): Promise<CommonMessages> {
  let effectiveLocale = locale;
  if (!locales.includes(locale as Locales) && locale !== 'de') {
    effectiveLocale = 'en';
  }

  // Use getSharedData for caching
  const cacheKey = `commonMessages:${effectiveLocale}`;
  return getSharedData(
    () => commonImport[effectiveLocale as Locales](),
    cacheKey
  );
}
export default getCommonMessages;
